<template>
  <form ref="form" class="forget-password__form" @submit.prevent="valid() ? forget() : null" novalidate>

    <h2 v-if="isBlocked" class="has-text-centered"><strong>Usuário Bloqueado</strong></h2>
    <h2 v-else class="has-text-centered"><strong>Redefinir a sua senha</strong></h2>

    <p class="is-size-7 has-text-centered login__info">
      <span v-if="!isSuccess&&!isBlocked">
        Por favor, digite o seu endereço de e-mail.
        Iremos lhe enviar um link no qual você poderá alterar sua senha.
      </span>
      <span v-if="!isSuccess&&isBlocked">
        Por motivos de segurança seu usuário foi bloqueado, mas não se preocupe!
        Informe seu e-mail abaixo e enviaremos um e-mail com as instruções para redefinir sua senha e restaurar o acesso à plataforma.
      </span>
      <span v-if="isSuccess">
        Se o endereço de e-mail fornecido estiver registrado em nosso sistema,
        você receberá um link para redefinir a sua senha.
        Por favor, verifique a sua conta de e-mail.
      </span>
    </p>

    <sc-field v-if="!isSuccess">
      <sc-input type="email" name="email" ref="email" placeholder="Informe seu e-mail" v-model="emailForget" required />
    </sc-field>

    <div class="buttons is-right">
      <sc-button :text="`${isSuccess ? 'Voltar' : 'Cancelar'}`" @click="back" />
      <sc-button type="submit" theme="primary" text="Enviar" v-if="!isSuccess" :loading="isLoading" />
    </div>
  </form>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { Http } from '@intelipost-js/secure-providers';
import { ScField, ScInput, ScButton } from '@intelipost-js/secure-components';

const { mapActions } = createNamespacedHelpers('auth');

export default {
  name: 'form-forget-password',
  props: {
    email: {
      type: String,
    },
    isForgetPassword: {
      type: Boolean,
    },
    isBlocked: {
      type: Boolean,
    },
  },
  data() {
    return {
      emailForget: this.email,
      isSuccess: false,
      isLoading: false,
    };
  },
  methods: {
    ...mapActions(['forgotPassword', 'forgotPasswordMigrated']),
    forget() {
      this.isLoading = true;

      return Http.post('api/v1/user/migrated', {
        email: this.emailForget,
      })
        .then((response) => {
          const { data } = response;
          const { migrated } = data.content;

          const forgotPasswordMethod = migrated ? this.forgotPasswordMigrated : this.forgotPassword;

          this.isLoading = true;

          return forgotPasswordMethod(this.emailForget)
            .then(() => {
              this.isSuccess = true;
              this.isLoading = false;
            })
            .catch(() => { this.isLoading = false; });
        })
        .catch(() => { this.isLoading = false; });
    },
    valid() {
      const { email } = this.$refs;
      return email.checkHtml5Validity();
    },
    back() {
      this.$emit('update:isForgetPassword', false);
      this.isSuccess = false;
    },
  },
  components: {
    ScField,
    ScInput,
    ScButton,
  },
};
</script>



// WEBPACK FOOTER //
// src/features/public/login/default/forms/FormForgetPassword.vue?67746d37